module.exports = __webpack_public_path__ + "img/a17.7f814e3f.svg";